jQuery(document).ready(function ($) {

    // Quantity Increment/Decrement
    $('.wishlist-table').on('click', '.qty-btn', function () {
        const $input = $(this).siblings('input.qty-input');
        let qty = parseInt($input.val(), 10);

        if ($(this).hasClass('qty-plus')) {
            qty++;
        } else if ($(this).hasClass('qty-minus') && qty > 1) {
            qty--;
        }
        $input.val(qty);
    });

});
